// @ts-nocheck
import {
  Box,
  Heading,
  PlayIcon,
  Text,
} from "@smoothie-framework/ui";
import { asset } from "./shared";


export function Cinema() {
  return (
    <Box
      as="section"
      className="cinema section-dark"
      background="background"
      minH={{ base: 207.5, lg: 240 }}
    >
      <img
        className="cinema-bg"
        src={asset("cinema-bg.png")}
        alt=""
        aria-hidden="true"
      />
      <img
        className="cinema-vignette"
        src={asset("cinema-vignette.png")}
        alt=""
        aria-hidden="true"
      />
      <Box className="film-stack" h={240} w={187.25}>
        <img
          className="film film-left"
          src={asset("cinema-mystery.png")}
          alt="A vertical micro-drama still"
        />
        <Box className="phone" background="surface1" h={185} p={3} w={90}>
          <Box
            className="phone-screen"
            background="background"
            h="full"
            w="full"
          >
            <img
              src={asset("cinema-phone.png")}
              alt="A vertical episode playing on a phone"
            />
            <Box
              aria-hidden="true"
              as="span"
              background="text"
              className="phone-play-affordance"
              display="grid"
              h={16}
              placeItems="center"
              rounded="full"
              w={16}
            >
              <PlayIcon size="md" />
            </Box>
            <span className="dynamic-island" />
            <span className="home-indicator" />
          </Box>
        </Box>
        <img
          className="film film-right"
          src={asset("cinema-other.png")}
          alt="A second vertical micro-drama still"
        />
        <span aria-hidden="true" className="phone-button phone-button-action" />
        <span
          aria-hidden="true"
          className="phone-button phone-button-volume-up"
        />
        <span
          aria-hidden="true"
          className="phone-button phone-button-volume-down"
        />
        <span aria-hidden="true" className="phone-button phone-button-side" />
      </Box>
      <Box className="cinema-copy" maxW={140}>
        <Heading level={2} textStyle="h1">
          Big stories.
          <br />
          Made for a small screen.
        </Heading>
        <Text as="p" textStyle="body" color="subtle" mt={{ base: 5, md: 7 }}>
          Secret romances, dark mysteries or worlds of your own. Turn the
          stories you love into vertical episodes that leave viewers wanting
          more.
        </Text>
      </Box>
    </Box>
  );
}
